module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/unidades/unidades.component.css
// module id = ./src/app/unidades/unidades.component.css
// module chunks = main